import * as Matches from './Matches';
import * as Authentication from './Authentication';
import * as Permissions from './Permissions';
import * as HostingRules from './HostingRules';
import * as UBL from './UBL';
import * as ServerTime from './ServerTime';
import * as Alerts from './Alerts';
import * as Errors from './Errors';

export const MatchesApi = Matches;
export const AuthenticationApi = Authentication;
export const PermissionsApi = Permissions;
export const HostingRulesApi = HostingRules;
export const UBLApi = UBL;
export const ServerTimeApi = ServerTime;
export const AlertsApi = Alerts;
export const ApiErrors = Errors;
